import React from 'react';
import PropTypes from 'prop-types';

import styles from './company-info.scss';

const CompanyInfo = ({
  headline, content, address, phoneLink, phone, email, organizationNumber,
}) => (
  <div className={styles.companyInfo}>
    <div className={styles.infoWrapper}>
      <div className={styles.content}>
        <h2>{headline}</h2>
        {content}
      </div>

      <div className={styles.contactDetails}>
        <div className={styles.contactDetail}>
          <h3>Företagsadress</h3>
          <address>
            {address}
          </address>
        </div>
        <div className={styles.contactDetail}>
          <h3>Direktkontakt</h3>
          <div><a href={`tel:${phoneLink}`}>{phone}</a></div>
          <div><a href={`mailto:${email}`}>{email}</a></div>
        </div>
        <div className={styles.contactDetail}>
          <h3>Organisationsnummer</h3>
          {organizationNumber}
        </div>
      </div>
    </div>
  </div>
);

CompanyInfo.propTypes = {
  headline: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  address: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  phoneLink: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  organizationNumber: PropTypes.string.isRequired,
};

export default CompanyInfo;



// WEBPACK FOOTER //
// ./blocks/CompanyInfo/index.js